export default __webpack_public_path__ + "static/media/few_clouds.043e2d1c.png";